<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      {{ item.vacancies_count }}
    </td>
    <td>
      <div
        class="buttons"
        v-if="
          $userCheckAccess({
            abilities: 'edit_work_roles',
          })
        "
      >
        <EmployeeRolesModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-employee_roles']['dialog_delete'][
              'udalit-dolzhnost'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import EmployeeRolesModal from 'components/setting/employeeRoles/EmployeeRolesModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'EmployeeRolesTableItem',
  components: { EmployeeRolesModal, DeleteModal },
  props: ['item'],
}
</script>
